import { createClient } from '@urql/vue';
// eslint-disable-next-line import/no-cycle
import { getAuthHeaders } from '@/composables/nestApi';

export default createClient({
  url: '/api/graphql',
  fetchOptions: () => ({ headers: getAuthHeaders() }),
});
